import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "sonner";
import "@/App.css";
import Layout from "./components/Layout";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import Works from "./pages/Works";
import WorkDetail from "./pages/WorkDetail";
import Exhibitions from "./pages/Exhibitions";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import Success from "./pages/Success";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <LanguageProvider>
          <AuthProvider>
            <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/works" element={<Works />} />
                  <Route path="/works/:id" element={<WorkDetail />} />
                  <Route path="/exhibitions" element={<Exhibitions />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/success" element={<Success />} />
                  <Route path="/admin/login" element={<Login />} />
                  <Route path="/admin" element={<Admin />} />
                </Routes>
              </Layout>
              <Toaster position="bottom-right" theme="system" />
            </BrowserRouter>
      </HelmetProvider>
          </AuthProvider>
        </LanguageProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
